import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import classNames from 'volta/helpers/class-names';
import { hash } from '@ember/helper';
import BvLabelled from 'volta/components/bv-labelled';
import BvInline from 'volta/components/bv-inline';
import Item from 'volta/components/bv-form-layout/item';

import type { ComponentLike } from '@glint/template';
import type { BvStackSignature } from 'volta/components/bv-stack';
import type { BvFormLayoutItemSignature } from 'volta/components/bv-form-layout/item';

export interface BvFormLayoutGroupSignature {
  Args: {
    text?: string;
    condensed?: boolean;
    title?: string;
    helpText?: string;
    error?: TFieldError;
    id?: string;
  };
  Blocks: {
    default: [{ Item: ComponentLike<BvFormLayoutItemSignature> }];
  };
  Element: BvStackSignature['Element'];
}

export default class BvFormLayoutGroupComponent extends Component<BvFormLayoutGroupSignature> {
  get id() {
    return this.args.id ?? guidFor(this);
  }

  <template>
    <BvLabelled
      @label={{@title}}
      @helpText={{@helpText}}
      @error={{@error}}
      class={{classNames (if @condensed 'bv-form-layout--condensed')}}
      role='group'
      id={{this.id}}
      ...attributes
    >
      <BvInline @gap='3' class='bv-form-layout__items'>
        {{#if (has-block)}}
          {{yield (hash Item=(component Item))}}
        {{else}}
          {{@text}}
        {{/if}}
      </BvInline>
    </BvLabelled>
  </template>
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvFormLayout::Group': typeof BvFormLayoutGroupComponent;
    'bv-form-layout/group': typeof BvFormLayoutGroupComponent;
  }
}
